import isNil from 'lodash.isnil';

export function isBlank(s: string | undefined | null): boolean {
  return isNil(s) || (typeof s === 'string' && s.trim() === '');
}

export default isBlank;
